import React, { useEffect, useState } from "react";
import { IonButton, IonCheckbox, IonInput, IonModal } from "@ionic/react";
import "./AvailabListEdit.scss";
import dayjs from "dayjs";
import DatePickerComponent from "../../../../../../../../../components/Shared/DatePicker/datepicker-component";
import TimePicker from "../../../../../../../../../components/Shared/TimePicker/timepicker-component";
import { utilService } from "../../../../../../../../../services";
import { availabListService } from "../../../../../AvailabilityList.service";
import { RespAvailaListEditModel } from "../AvailabListEdit/Models/AvailabListEdit.model";
import { useToast } from "@agney/ir-toast";
import { isPlatform } from "@ionic/react";
import { useTranslation } from "react-i18next";
import moment from "moment";



interface EditProps {
  onCancel: () => void;
  availableListCardData?: any;
  loadData?: any;
  isTemplateAdd?: boolean;
}

const AvailabListEdit: React.FC<EditProps> = (props) => {
  useEffect(() => {
    if (isPlatform("ios")) {
      setIsIos(true);
    }
  }, []);

  const Toast = useToast();
  const { t } = useTranslation("schedule");
  var [checked, setChecked] = useState(false);
  var [pickerStartTime, setPickerStartTime]: any = useState();
  var [pickerEndTime, setPickerEndTime]: any = useState();
  const [isIos, setIsIos] = useState(false);

  var [fromDate, setFromDate]: any = useState();
  var [toDate, setToDate]: any = useState();

  const [isLoaderActive, setLoaderStatus] = useState(true);

  const [showStartDatePickerModal, setStartDatePickerModal] = useState(false);
  const [showStartTimePickerModal, setStartTimePickerModal] = useState(false);
  const [showExpiryDatePickerModal, setExpiryDatePickerModal] = useState(false);
  const [showExpiryTimePickerModal, setExpiryTimePickerModal] = useState(false);

  useEffect(() => {
    if (props) {
      setPickerStartTime(props?.availableListCardData?.data[0]?.startTime);
      setPickerEndTime(props?.availableListCardData?.data[0]?.endTime);
    }
  }, [props]);

  useEffect(() => {
    if (props) {
      setFromDate(props?.availableListCardData?.startDate?? dayjs().format("YYYY-MM-DD"));
      setToDate(props?.availableListCardData?.endDate??dayjs().format("YYYY-MM-DD"));
    }
  }, [props]);

  async function submitAvailableListDetails() {
    setLoaderStatus(true);
    const params: any = getParams();
    if (pickerStartTime && pickerEndTime) {
      if (fromDate && toDate) {
        if (dayjs(toDate).isAfter(fromDate)) {
          if (
            props.availableListCardData.data[0].active === true ||
            props.availableListCardData.data[1].active === true ||
            props.availableListCardData.data[2].active === true ||
            props.availableListCardData.data[3].active === true ||
            props.availableListCardData.data[4].active === true ||
            props.availableListCardData.data[5].active === true ||
            props.availableListCardData.data[6].active === true
          ) {
            update(params);
          } else {
            Toast.error(t("selectWeekDays"));
          }
        } else {
          Toast.error(t("validEndDate"));
        }
      } else {
        Toast.error(t("selectDates"));
      }
    } else {
      Toast.error(t("selectTime"));
    }
  }

  const update = async (params: any) => {
    const respAvailabListEditResult: RespAvailaListEditModel =
      await availabListService.submitAvailabilityList(params);
    if (
      respAvailabListEditResult.isSuccess &&
      respAvailabListEditResult.result
    ) {
      availabListService.reloadAvailabListData();
      Toast.success(respAvailabListEditResult.message);
      props.onCancel();
    } else {
      Toast.error(respAvailabListEditResult.message);
      availabListService.handleErrorResponse();
    }

    setLoaderStatus(false);
  };

  const getParams = () => {
    var dayStartTime = mapPickerTimeParams(pickerStartTime);
    var dayEndTime = mapPickerTimeParams(pickerEndTime);
    const params: any = {
      page: 1,
      start_date: moment(fromDate).format("YYYY-MM-DD"),
      end_date: moment(toDate).format("YYYY-MM-DD"),
      reg_code: utilService.getNetwork(),
      data: {
        sun: {
          id: 0,
          start_time: dayStartTime,
          end_time: dayEndTime,
          active: props.availableListCardData.data[0].active,
        },
        mon: {
          id: 1,
          start_time: dayStartTime,
          end_time: dayEndTime,
          active: props.availableListCardData.data[1].active,
        },
        tue: {
          id: 2,
          start_time: dayStartTime,
          end_time: dayEndTime,
          active: props.availableListCardData.data[2].active,
        },
        wed: {
          id: 3,
          start_time: dayStartTime,
          end_time: dayEndTime,
          active: props.availableListCardData.data[3].active,
        },
        thu: {
          id: 4,
          start_time: dayStartTime,
          end_time: dayEndTime,
          active: props.availableListCardData.data[4].active,
        },
        fri: {
          id: 5,
          start_time: dayStartTime,
          end_time: dayEndTime,
          active: props.availableListCardData.data[5].active,
        },
        sat: {
          id: 6,
          start_time: dayStartTime,
          end_time: dayEndTime,
          active: props.availableListCardData.data[6].active,
        },
      },
    };
    if (props.availableListCardData.id) {
      params["id"] = props.availableListCardData.id;
    } else {
      params["guid"] = utilService.getLoggedUserGuid();
    }
    return params;
  };

  const mapPickerTimeParams = (pickerTime: string) => {
    if (pickerTime.length < 8) {
      return pickerTime + ":00";
    } else {
      return pickerTime;
    }
  };

  const checkboxClick = (e: boolean, items: any) => {
    var status: any = props.availableListCardData.data.find(
      (item: any) => item.id === items.id
    );
    var statusValue = e ? (status.active = true) : (status.active = false);
  };

  const FormatSelectedDate = (date: string,isStartDate:boolean) => {
    const formatedDate = dayjs(date).format("MMM DD, YYYY");
    
    return formatedDate;
  };

  return (
    <div>
      <IonModal
        isOpen={showStartDatePickerModal}
        className="time-picker-modal"
        backdropDismiss={false}
      >
        <DatePickerComponent
          getSelectedDate={(value: string) => {
            setFromDate(value);
          }}
          isDateShort={true}
          dateFromParent={
            props.isTemplateAdd
              ? undefined
              : dayjs(props.availableListCardData.startDate).format("YYYY-MM-DD") 
          }
        ></DatePickerComponent>
        <div className="reminder-button-container">
          <div className="send-button-div">
            <IonButton
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                setStartDatePickerModal(false);
              }}
            >
              {t("add")}
            </IonButton>
          </div>
        </div>
      </IonModal>
      <IonModal
        isOpen={showExpiryDatePickerModal}
        className="time-picker-modal"
        backdropDismiss={false}
      >
        <DatePickerComponent
          getSelectedDate={(value: string) => {
            setToDate(value);
          }}
          isDateShort={true}
          dateFromParent={
            props.isTemplateAdd
              ? undefined
              : props.availableListCardData.endDate
          }
        ></DatePickerComponent>
        <div className="reminder-button-container">
          <div className="send-button-div">
            <IonButton
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                setExpiryDatePickerModal(false);
              }}
            >
              {t("add")}
            </IonButton>
          </div>
        </div>
      </IonModal>
      <IonModal
        isOpen={showStartTimePickerModal}
        className="time-picker-modal"
        backdropDismiss={false}
      >
        <TimePicker
          getSelectedTime={(value: string) => {
            let formattedStartTime = moment(value, "HH:mm").format("hh:mm A");
            setPickerStartTime(formattedStartTime);
          }}
        // timeValue={pickerStartTime}
        ></TimePicker>
        <div className="reminder-button-container">
          <div className="send-button-div">
            <IonButton
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                setStartTimePickerModal(false);
              }}
            >
              Add
            </IonButton>
          </div>
        </div>
      </IonModal>
      <IonModal
        isOpen={showExpiryTimePickerModal}
        className="time-picker-modal"
        backdropDismiss={false}
      >
        <TimePicker
          getSelectedTime={(value: string) => {
            let formattedEndTime = moment(value, "HH:mm").format("hh:mm A");
            setPickerEndTime(formattedEndTime);
          }}
        ></TimePicker>
        <div className="reminder-button-container">
          <div className="send-button-div">
            <IonButton
              className="submit-btn button primary-btn btn-curved"
              onClick={() => {
                setExpiryTimePickerModal(false);
              }}
            >
              {t("add")}
            </IonButton>
          </div>
        </div>
      </IonModal>

      <div className="availab-list-container">
        <div className="availability-back" onClick={props.onCancel}>
          <div className="availability-back-icon icon-back"></div>
          <div className="availability-back-header">
         {t("manageAvailabilityTemplates")}
          </div>
        </div>
        <div className="edit-card-data">
          <div className="calendar-picker-container">
            <div className="calendar-wrapper">
              <span className="date-title">{t("startDate")}</span>
              <span className="calendar-card-from">
                <IonInput
                  id="inputSec"
                  name="display"
                  className="emt-sac-input"
                  value={FormatSelectedDate(fromDate,true)}
                  onClick={() => setStartDatePickerModal(true)}
                  
                ></IonInput>
              </span>
            </div>
            <div className="calendar-wrapper">
              <span className="date-title">{t("endDate")}</span>
              <span className="calendar-card-to">
                <IonInput
                  id="inputSec"
                  name="display"
                  className="emt-sac-input"
                  value={FormatSelectedDate(toDate,false)}
                  onClick={() => setExpiryDatePickerModal(true)}
                  
                ></IonInput>
              </span>
            </div>
          </div>
          <div className="week-day-container">
            <div className="day-title">{t("selectDay")}</div>
            {props.availableListCardData &&
              props.availableListCardData.data.length > 0 ? (
              props.availableListCardData.data.map((items: any) => {
                return (
                  <div className="week-day-wrapper">
                    <span className="checkbox">
                      <IonCheckbox
                        id="checkbox"
                        color="dark"
                        checked={items.active}
                        item-left
                        onIonChange={(e) => {
                          checkboxClick(e.detail.checked, items);
                          setChecked(e.detail.checked);
                        }}
                      ></IonCheckbox>
                    </span>
                    <span
                      className={`checkbox-label ${isIos && "checkbox-label-ios"
                        }`}
                    >
                      <span className="checkbox-labels">{items.name}</span>
                    </span>
                  </div>
                );
              })
            ) : (
              <div>{"No result"}</div>
            )}
          </div>
          <div className="time-picker-container">
            <div className="time-wrapper">
              <span className="time-header">{t("fromTime", "From Time")}</span>
              <span className="time-value-start">
                <IonInput
                  id="inputSec"
                  name="display"
                  className=" selectedTimeInput"
                  value={pickerStartTime}
                  onClick={() => setStartTimePickerModal(true)}
                  
                ></IonInput>
              </span>
            </div>
            <div className="time-wrapper">
              <span className="time-header">{t("toTime", "To Time")}</span>
              <span className="time-value-end">
                <IonInput
                  id="inputSec"
                  name="display"
                  className="selectedTimeInput"
                  value={pickerEndTime}
                  onClick={() => setExpiryTimePickerModal(true)}
                  
                ></IonInput>
              </span>
            </div>
          </div>
        </div>
        <div className="availability-footer">
          <div className="buttons-div">
            <div className="cancel">
              <IonButton
                color="medium"
                className="rounded-btn secondary-btn cancel-btn btn-curved"
                onClick={() => props.onCancel()}
              >
                 {t("cancel")}
              </IonButton>
            </div>
            <div className="submit">
              <IonButton
                className="primary-btn button btn-curved"
                onClick={(event) => {
                  submitAvailableListDetails();
                }}
              >
               {t("submit")}
              </IonButton>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default AvailabListEdit;
